export const environment = {
  production: true,
  entorno: "Produccion",
  buildNumber: 'InmobiliariaMassoud-UI_CI-Massoud.UI.Prod_main_20260712.2',
  appInsights: {
    instrumentationKey: '363fa37d-1684-4082-98cb-b43dd9c3f700'
}
};
